<template>
    <div class="menu-page">
        <h1>Aprovação de Lojistas</h1>

        <div class="find-bar mb-4">
            <v-text-field autocomplete="nope" dense v-model="filter" label="Filtro por nome, estado, cidade ou telefone" outlined hide-details="auto"></v-text-field>
        </div>

        <div>
            <v-data-table :headers="headers" no-data-text="Sem novas solicitações" :items="store_registers" :search="filter" :items-per-page="50" class="elevation-1" :footer-props="{
                'items-per-page-text': 'Linhas por página',
                'items-per-page-all-text': 'Tudo',
                'items-per-page-options': [5, 10, 30, 50, 100, -1],
            }">

                <template v-slot:[`item.created`]="{ item }">
                    {{ new Date(item.created).toLocaleString() }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <div class="actions-container">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon medium class="mr-4" color="primary" @click.stop="new_store = item; modalNewStore = true" v-bind="attrs" v-on="on"> mdi-eye-outline</v-icon>
                            </template>
                            <span>Ver detalhes</span>
                        </v-tooltip>

                        <v-tooltip left v-if="item.status == 'Novo'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon medium class="mr-4" color="success" @click.stop="new_store = item; dialogAprova = true" v-bind="attrs" v-on="on"> mdi-check-outline</v-icon>
                            </template>
                            <span>Aprovar cadastro</span>
                        </v-tooltip>

                        <v-tooltip left v-if="item.status == 'Novo'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon medium class="mr-4" color="error" @click.stop="new_store = item; dialog = true" v-bind="attrs" v-on="on"> mdi-trash-can-outline</v-icon>
                            </template>
                            <span>Reprovar cadastro</span>
                        </v-tooltip>
                    </div>
                </template>
            </v-data-table>
        </div>

        <v-bottom-sheet v-model="modalNewStore">
            <v-sheet class="bottom-modal-container" height="auto">
                <v-row>
                    <v-col cols="12" lg="4" md="4" sm="6">
                        <v-text-field autocomplete="nope" disabled dense v-model="new_store.store_name" label="Nome da loja" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="6">
                        <v-text-field autocomplete="nope" disabled maxlength="60" dense v-model="new_store.store_state" label="Estado da loja" outlined hide-details="auto"></v-text-field>
                    </v-col>

                    <v-col cols="12" lg="4" md="4" sm="6">
                        <v-text-field autocomplete="nope" disabled maxlength="60" dense v-model="new_store.store_city" label="Cidade da loja" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="6">
                        <v-text-field autocomplete="nope" disabled maxlength="60" dense v-model="new_store.store_phone" label="Telefone" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="6">
                        <v-text-field autocomplete="nope" disabled maxlength="60" dense v-model="new_store.store_cnpj" label="CNPJ" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="6">
                        <v-text-field autocomplete="nope" disabled maxlength="60" dense v-model="new_store.user_name" label="Nome do responsável" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="6">
                        <v-text-field autocomplete="nope" disabled maxlength="60" dense v-model="new_store.user_email" label="E-mail" outlined hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4" md="4" sm="6">
                        <v-text-field autocomplete="nope" disabled maxlength="60" dense :value="new Date(new_store.created).toLocaleString()" label="Data do pedido" outlined hide-details="auto"></v-text-field>
                    </v-col>

                </v-row>
            </v-sheet>
        </v-bottom-sheet>

        <v-dialog v-model="dialog" max-width="350">
            <v-card>
                <v-card-title class="text-h5">
                    Reprovar solicitação
                </v-card-title>
                <v-card-text>Tem certeza que deseja reprovar a solicitação da loja <b>{{ new_store.store_name }}</b>?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="error" text @click="dialog = false; reproveStoreRegister()">
                        Reprovar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAprova" max-width="350">
            <v-card>
                <v-card-title class="text-h5">
                    Aprovar solicitação
                </v-card-title>
                <v-card-text>Tem certeza que deseja aprovar a solicitação da loja <b>{{ new_store.store_name }}</b>?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogAprova = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="success" text @click="dialogAprova = false; approveStoreRegister()">
                        Aprovar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";

export default {
    name: "StoreRegistersView",

    data() {
        return {
            store_registers: [],
            modalNewStore: false,
            new_store: {},
            filter: "",
            noDataText: "Nenhuma opção",
            buttonLoading: false,
            dialog: false,
            dialogAprova: false,
            headers: [
                { text: "Data solicitação", value: "created", filterable: true },
                { text: "Nome da loja", value: "store_name", filterable: true },
                { text: "Cidade", value: "store_city", filterable: true },
                { text: "Estado", value: "store_state", filterable: true },
                { text: "Cidade", value: "store_phone", filterable: true },
                { text: "CNPJ", value: "store_cnpj", filterable: true },
                { text: "E-mail", value: "user_email", filterable: true },
                { text: "Status", value: "status", filterable: true },
                { text: "Ações", value: "actions" },
            ]
        };
    },


    async mounted() {
        await this.getStoreRegisters();
    },

    methods: {

        async getStoreRegisters() {
            const resp = await Api.getStoreRegisters();
            if (resp && resp.message) this.store_registers = resp.message;
        },

        limpaFormulario() {
            this.new_store = {};
        },

        async approveStoreRegister() {


            let resp = await Api.createOrUpdateStore({ name: this.new_store.store_name, state: this.new_store.store_state, city: this.new_store.store_city, phone: this.new_store.store_phone, cnpj: this.new_store.store_cnpj, user_email: this.new_store.user_email });
            if (resp.error) {
                return emitToastr("error", "Erro ao criar a loja. Verifique as informações de cadastro e tente novamente.");
            }

            resp = await Api.createOrUpdateUser({ name: this.new_store.user_name, email: this.new_store.user_email, password: this.new_store.user_password, admin: false, status: 'active', is_car_dealer: true, store: resp.message._id });
            if (resp.error) {
                return emitToastr("error", "Erro ao criar o usuário. Verifique as informações de cadastro e tente novamente. Verifique se o email deste usuário já existe no sistema.");
            }

            this.new_store.status = 'Aprovado';
            resp = await Api.createOrUpdateStoreRegister(this.new_store);
            if (resp && !resp.error) {
                this.buttonLoading = false;
                this.getStoreRegisters();
                return emitToastr('success', 'Solicitação aprovada com sucesso.');
            }
        },

        async reproveStoreRegister() {
            this.new_store.filed = true;
            this.new_store.status = 'Reprovado';

            const resp = await Api.createOrUpdateStoreRegister(this.new_store);
            if (resp && !resp.error) {
                this.buttonLoading = false;
                this.getStoreRegisters();
                return emitToastr('success', 'Solicitação reprovada com sucesso.');
            }
        }
    },
};
</script>
  
<style scoped>
.find-bar {
    display: flex;
    flex-direction: row;
    max-width: 400px;

}

.new-store-button {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
}

.actions-container {
    display: flex;
    flex-direction: row;

}

.bottom-modal-container {
    padding: 4%;
}

@media only screen and (max-width: 768px) {}
</style>
  